<punches-nav></punches-nav>

<div class="violations-wrapper">
    <div class="toast show" *ngIf="toastMessage" [class.success]="toastKind === 'success'"
        [class.error]="toastKind === 'error'" [class.warning]="toastKind === 'info'" (click)="clearToast()"
        role="status" aria-live="polite">
        <img class="icon"
            [src]="toastKind === 'success' ? '/success.png' : toastKind === 'error' ? '/fail.png' : '/warning.png'"
            alt="" aria-hidden="true" />

        <div class="toast-title">
            {{ toastKind === 'success' ? 'Success' : toastKind === 'error' ? 'Action needed' : 'Notice' }}
        </div>

        <div class="toast-body">{{ toastMessage }}</div>
    </div>

    <div class="page-header" *ngIf="!isLoading">
        <h2>Violations</h2>
    </div>

    <div class="pagination-bar" *ngIf="!isLoading && !errorMessage && violations.length > 0">
        <div class="page-controls">
            <button class="nav-btn" (click)="prevPage()" [disabled]="currentPage === 1">← Prev</button>
            <span>Page {{ currentPage }} of {{ totalPages }}</span>
            <button class="nav-btn" (click)="nextPage()" [disabled]="currentPage === totalPages">Next →</button>
        </div>

        <div class="page-size">
            <label for="pageSize">Page Size</label>
            <select id="pageSize" [(ngModel)]="pageSize" (change)="changePageSize()">
                <option *ngFor="let size of pageSizeOptions" [value]="size">{{ size }}</option>
            </select>
        </div>
    </div>

    <div class="filters-container" *ngIf="!isLoading">
        <div class="filters-row">
            <label class="filter-field">
                <span>Company</span>
                <select [(ngModel)]="filters.companyId" (ngModelChange)="onCompanyChange($event)"
                    [disabled]="companiesIsLoading">
                    <option [ngValue]="null">All companies</option>
                    <option *ngFor="let company of companies" [ngValue]="company.id">
                        {{ company.name }}
                    </option>
                </select>
            </label>

            <label class="filter-field">
                <span>Department</span>
                <select [(ngModel)]="filters.departmentId" (ngModelChange)="onDepartmentChange($event)"
                    [disabled]="departmentsIsLoading">
                    <option [ngValue]="null">All departments</option>
                    <option *ngFor="let department of departments" [ngValue]="department.id">
            {{ department.code }} - {{ department.name }}
                    </option>
                </select>
            </label>

            <label class="filter-field search-field">
                <span>Search</span>
                <input type="text" [(ngModel)]="filters.searchTerm" (ngModelChange)="onSearchTermChange($event)"
                    placeholder="Search employee name" />
            </label>

            <div class="filter-actions">
                <button class="nav-btn clear-filters-btn" type="button" (click)="clearFilters()"
                    [disabled]="!hasActiveFilters">
                    Clear Filters
                </button>
            </div>
        </div>

        <div class="filter-status-row">
            <div class="filter-status error" *ngIf="companiesError">{{ companiesError }}</div>
            <div class="filter-status error" *ngIf="departmentsError">{{ departmentsError }}</div>
        </div>
    </div>

    <div *ngIf="isLoading" class="loading-overlay">
        <div class="spinner"></div>
    </div>

    <div *ngIf="errorMessage" class="error-message">
        {{ errorMessage }}
    </div>

    <div class="no-data" *ngIf="!isLoading && !errorMessage && !violations.length">
        No violations found.
    </div>

    <div class="violations-list" *ngIf="!isLoading && !errorMessage && violations.length">
        <div *ngFor="let violation of violations; trackBy: trackByViolationId" class="violation-card"
            [class.violation-state]="isViolation(violation)" [class.approved-state]="isApproved(violation)"
            [class.expanded]="isExpanded(violation.id)">
            <div class="violation-main" (click)="toggleExpanded(violation.id)">
                <div class="violation-left">
                    <div class="employee-row">
                        <div class="employee-name">{{ getEmployeeFullName(violation) }}</div>

                        <span class="status-pill" [class.status-pill-violation]="isViolation(violation)"
                            [class.status-pill-approved]="isApproved(violation)">
                            {{ getApprovalStatusLabel(violation) }}
                        </span>
                    </div>

                    <div class="employee-meta">
                        <span>Emp # {{ getEmployeeNumber(violation) }}</span>
                        <span>RFID {{ getEmployeeRfid(violation) }}</span>
                        <span>Manager {{ getManagerName(violation) }}</span>
                    </div>
                </div>

                <div class="violation-middle">
                    <div class="summary-item">
                        <span class="label">Type</span>
                        <span class="value">{{ getViolationType(violation) }}</span>
                    </div>

                    <div class="summary-item">
                        <span class="label">Punch</span>
                        <span class="value">{{ getLogTypeLabel(violation) }}</span>
                    </div>

                    <div class="summary-item">
                        <span class="label">Time</span>
                        <span class="value">{{ formatLogDateTime(violation.logTime) }}</span>
                    </div>
                </div>

                <div class="violation-actions" (click)="$event.stopPropagation()">
                    <button class="action-btn" [class.approve-btn]="isViolation(violation)"
                        [class.reject-btn]="isApproved(violation)" [disabled]="isTogglingApproval(violation.id)"
                        (click)="openConfirmModal(violation)">
                        {{ isTogglingApproval(violation.id) ? 'Saving...' : getApprovalButtonText(violation) }}
                    </button>
                </div>
            </div>

            <div class="violation-details" *ngIf="isExpanded(violation.id)">
                <div class="details-grid">
                    <div class="detail-card">
                        <span class="detail-label">Violation ID</span>
                        <span class="detail-value">{{ violation.id }}</span>
                    </div>

                    <div class="detail-card">
                        <span class="detail-label">Violation Type</span>
                        <span class="detail-value">{{ getViolationType(violation) }}</span>
                    </div>

                    <div class="detail-card">
                        <span class="detail-label">Punch Type</span>
                        <span class="detail-value">{{ getLogTypeLabel(violation) }}</span>
                    </div>

                    <div class="detail-card">
                        <span class="detail-label">Punch Time</span>
                        <span class="detail-value">{{ formatLogDateTime(violation.logTime) }}</span>
                    </div>

                    <div class="detail-card">
                        <span class="detail-label">Schedule</span>
                        <span class="detail-value">{{ getScheduleText(violation) }}</span>
                    </div>

                    <div class="detail-card">
                        <span class="detail-label">Verified At</span>
                        <span class="detail-value">{{ formatVerifiedDateTime(violation.violation?.verifiedAt) }}</span>
                    </div>

                    <div class="detail-card detail-card-wide">
                        <span class="detail-label">Verified By</span>
                        <span class="detail-value">{{ getVerifiedByName(violation) }}</span>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>

<div *ngIf="confirmModalOpen" class="modal-backdrop">
  <div class="modal confirm-modal" (click)="$event.stopPropagation()">
    <h2>{{ getConfirmModalTitle() }}</h2>

    <p class="modal-text">
      Are you sure you want to
      <strong>{{ getConfirmButtonText().toLowerCase() }}</strong>
      <strong>{{ getViolationType(violationToConfirm!) }}</strong>
      for
      <strong>{{ getEmployeeFullName(violationToConfirm!) }}</strong>?
    </p>

    <div class="modal-buttons confirm-buttons">
      <button type="button" class="btn btn-secondary" (click)="closeConfirmModal()">
        Cancel
      </button>

      <button
        type="button"
        class="btn"
        [class.btn-danger]="violationToConfirm && isApproved(violationToConfirm)"
        [class.btn-primary]="violationToConfirm && !isApproved(violationToConfirm)"
        (click)="confirmToggleApproval()"
      >
        {{ getConfirmButtonText() }}
      </button>
    </div>
  </div>
</div>